import { render } from "./EducationWidget.vue?vue&type=template&id=d2233428"
import script from "./EducationWidget.vue?vue&type=script&lang=js"
export * from "./EducationWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__